export default __webpack_public_path__ + "media/components/common/loader/loader-988ddf9a41d4d469c8ffb3db0660ffdf.svg";